import React from "react";
import { useState, useEffect, useContext } from "react";
import { useAuth } from "../../hooks/customers/AuthProvider";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import * as Config from "../../config/config";
import { LoaderContext } from "../utils/Contexts";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import Item from "../menu/Item";
function SearchResult(props) {
  const [existingItemsInCart, setExistingItemsInCart] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const { t } = useTranslation();
  const auth = useAuth();
  const { isLoader, setLoader } = useContext(LoaderContext);
  const cusId = auth.customer._id;
  const [favoriteProducts, setFavoriteProducts] = useState([]);

  useEffect(() => {
    // Fetch the favorite products for the user
    fetchFavorites();
  }, [cusId]);
  const fetchFavorites = () => {
    const response = API.getWithToken(
      `${ENDPOINTS.GET_FAVORITE_PRODUCTS_WITHOUT_LIMIT}/${cusId}`
    );
    response.then((res) => {
      if (res.statusText === "OK") {
        setFavoriteProducts(res.data.data.favourites);
      }
    });
  };

  const addToFavorite = async (event, item) => {
    setLoader(true);

    try {
      let response;
      let message;
      // Check if the product is already a favorite
      if (item.isFavorite(item._id)) {
        // If it is a favorite, remove it (use DELETE)
        response = await API.deleteWithToken(
          `${ENDPOINTS.DEL_FAVORITE_PRODUCTS}/${cusId}/${item._id}`
        );
        message = t("remove_favourite");
      } else {
        // If it is not a favorite, add it (use POST)
        response = await API.postWithToken(ENDPOINTS.ADD_FAVORITE_PRODUCTS, {
          productId: item._id,
          cusId: cusId,
        });
        message = t("added_to_favourite");
      }

      // Check if the request was successful
      if (response.statusText === "OK") {
        setError(null);
        toast.success(message, {
          position: "bottom-left",
        });

        fetchFavorites(); // Fetch the updated list after add/remove
      } else {
        toast.error(t("error_favourite"));
      }
    } catch (error) {
      // Handle errors (network, API issues, etc.)
      setSuccess(null);
      setError("An error occurred while processing your request.");
    }

    setLoader(false);
  };

  const isFavorite = (productId) => {
    return favoriteProducts.some(
      (fav) => fav.productId && productId && fav.productId._id === productId
    );
  };
  return (
    <div className="search-result">
      <div className="Favourites_title">
        <div className="Favourites_title_l">
          <h2>SEARCH RESULT(S)</h2>
        </div>
      </div>
      <div className="favmenuitem">
        {props.products.length > 0 &&
          props.products.map((item, index) => (
            <Item
              key={index}
              isFavorite={isFavorite}
              addToFavorite={addToFavorite}
              products={props.products}
              setError={setError}
              setSuccess={setSuccess}
              customer_id={cusId}
              existingItemsInCart={existingItemsInCart}
              {...item}
            />
          ))}
      </div>
    </div>
  );
}

export default SearchResult;
